
import { useState, useEffect } from 'react';
import ApiClient from '../../API/api';
import { useComercialContext } from '../../comercial/ComercialContext';

/**
 * Fetches the products belonging to a PRODUCT-scoped cart promotion group.
 * @param {number|null} promotionId
 */
export const usePromotionProducts = (promotionId) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const { actingAsCliente } = useComercialContext();

    useEffect(() => {
        if (!promotionId) {
            setProducts([]);
            return;
        }

        const fetchProducts = async () => {
            setLoading(true);
            try {
                const headers = actingAsCliente?.numCliente
                    ? { 'X-Acting-As-Client': actingAsCliente.numCliente }
                    : {};
                const response = await ApiClient.performRequest(
                    `cart-promotions/${promotionId}/products`, { headers }
                );
                setProducts(Array.isArray(response) ? response : []);
            } catch (err) {
                console.error('[OfertasCombinables] Error fetching products for promo', promotionId, err);
                setProducts([]);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [promotionId, actingAsCliente]);

    return { products, loading };
};
